import React from 'react';

import { DsFullPageError } from './ds';

type Estado = { quebrou: boolean; detalhe?: string };

/**
 * Rede de segurança do topo da árvore. O caso mais comum não é um bug de
 * render: é um `import()` de rota que falha porque saiu uma versão nova
 * enquanto a aba estava aberta, e o chunk que o navegador pede já não existe.
 * Sem isto, esse cenário dá tela branca sem nenhuma pista do que fazer.
 */
export class ErrorBoundary extends React.Component<{ children?: React.ReactNode }, Estado> {
  state: Estado = { quebrou: false };

  static getDerivedStateFromError(erro: Error): Estado {
    return { quebrou: true, detalhe: erro.message };
  }

  componentDidCatch(erro: Error, info: React.ErrorInfo) {
    console.error(erro, info.componentStack);
  }

  render() {
    if (!this.state.quebrou) return this.props.children;

    return (
      <DsFullPageError
        title="A tela não pôde ser aberta"
        message="Isso costuma acontecer quando sai uma versão nova com a aba já aberta. Recarregar resolve."
        onRetry={() => window.location.reload()}
        retryLabel="Recarregar a página"
        onHome={() => window.location.assign('/')}
        detail={this.state.detalhe}
      />
    );
  }
}
